import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["d"]

import { mdiAlertCircleOutline } from '@mdi/js'

export type LabelBadgeColor = 'blue' | 'orange' | 'green' | 'yellow' | 'red' | 'gray' | 'purple'
export type LabelBadgeSize = 'small' | 'medium'


export default /*#__PURE__*/_defineComponent({
  __name: 'LabelBadge',
  props: {
    label: {},
    color: { default: 'blue' },
    size: { default: 'medium' },
    icon: { default: mdiAlertCircleOutline }
  },
  setup(__props: any) {



const colorClasses: Record<LabelBadgeColor, string> = {
  blue: 'border-primary bg-primary5',
  orange: 'border-alert bg-orange-50',
  green: 'border-sucess bg-green-50',
  yellow: 'border-warning bg-yellow-50',
  red: 'border-negative bg-red-50',
  gray: 'border-gray-300 bg-gray-100',
  purple: 'border-purple-300 bg-purple-50'
}

const iconColorClasses: Record<LabelBadgeColor, string> = {
  blue: 'text-primary',
  orange: 'text-alert',
  green: 'text-sucess',
  yellow: 'text-warning',
  red: 'text-negative',
  gray: 'text-neutral50',
  purple: 'text-purple-700'
}

const sizeClasses: Record<LabelBadgeSize, string> = {
  small: 'text-xs px-2 py-0.5',
  medium: 'text-sm px-2.5 py-1'
}

const iconSizeClasses: Record<LabelBadgeSize, string> = {
  small: 'w-3.5 h-3.5',
  medium: 'w-4 h-4'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[colorClasses[_ctx.color], sizeClasses[_ctx.size]], "flex items-center gap-1 w-fit rounded border font-medium text-textPrimary"])
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          xmlns: "http://www.w3.org/2000/svg",
          class: _normalizeClass([iconSizeClasses[_ctx.size], iconColorClasses[_ctx.color]]),
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            d: _ctx.icon,
            fill: "currentColor"
          }, null, 8, _hoisted_1)
        ], 2))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
  ], 2))
}
}

})